import AuthMain from "./components/AuthMain";

function Auth() {
  return (
    <div className="flex_container">
      <main style={{ flex: "1 1 0" }} className="auth">
        <AuthMain />
      </main>
    </div>
  );
}

export default Auth;
